import React from "react";
import Footer_m from '../footer/Footer.js';
import Header_m from '../header/Header.js';
import BaseTamplate from "../Template/Template.js";
// .................................................
import backyard from'../../img/stone/backyard.jpg';
import backyard2 from'../../img/stone/backyard2.jpg';
import backyard4 from'../../img/stone/backyard4.jpg';
import backyard5 from'../../img/stone/backyard5.jpg';
import backyardcurve from'../../img/stone/backyardcurve.jpg';
import walkway from'../../img/stone/walkway.jpg';

import Grass from '../../img/grass1.jpg';

let pictureArray = [backyard4, backyard5, walkway,backyardcurve,backyard,backyard2];
let stoneWork = ['Walls','Pathways','Patios','Trim','Yards'];

const Stone =() =>{
    return(
        <div>
            {/* <Header_m></Header_m> */}

            <div className="container">

            <BaseTamplate pageName ="Stone" pictures = {pictureArray} Title="Stone Work" itemList={stoneWork}>
               {Grass}
            </BaseTamplate>

     

            </div>

            <Footer_m></Footer_m>
        </div>
    )

}

export default Stone;